export const applicationEndpoints = {
  // Endpoints publics du front OSER (sans authentification)
  publicConfig: 'public/config',
  publicSubsidiaries: 'public/subsidiaries',
  publicReports: 'public/reports',

  // Endpoints hérités du squelette MPS (non utilisés par le front public)
  users: 'users',
  all: 'users/all',
  usersToImpersonate: 'users/to-impersonate',
  impersonateUser: 'oauth2/impersonate/:userId',
  retrieveTranslations: 'lokalise/retrieveTranslationFiles',
  getRoleByCode: 'roles/get-by-code',
};
